import { combineReducers } from 'redux';
import dashboardReducers from './dashboard';
import filemanagerReducers from './filemanager';
import consoleReducers from './console';

const reducer = combineReducers({
	dashboard: dashboardReducers,
	filemanager: filemanagerReducers,
	console: consoleReducers
});

export default reducer;
